import ProductoCreate from './create'
import ProductoList from './list'

export default {
    list : ProductoList,
    create : ProductoCreate,
}